import { render } from "./Contact.vue?vue&type=template&id=ffdcc0b4"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=ffdcc0b4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__